export default __webpack_public_path__ + "static/media/Alert.c02e2e88.svg";